import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";

const Breadcrumb = () => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  const isNumericSegment = (value) => /^\d+$/.test(String(value || ""));

  const getClientLabel = (clientId) => {
    if (!clientId) return "Digicom Technology Solutions";
    return (
      sessionStorage.getItem(`pbx_client_name_${clientId}`) ||
      "Digicom Technology Solutions"
    );
  };

  // Map path segments to readable labels
  const getLabel = (path, index) => {
    const labelMap = {
      dashboard: "Dashboard",
      "user-managment": "User Management",
      roles: "Roles & Permissions",
      configuration: "PBX Configuration",
      logs: "Logs",
      usage: "Usage",
      analytics: "Analytics",
      billing: "Billing",
      referral: "Referral",
      notifications: "Notifications",
      settings: "Settings",
      support: "Help & Support",
      "contact-support": "Contact Support",
    };

    if (
      isNumericSegment(path) &&
      pathnames[index - 1] === "client-management"
    ) {
      return getClientLabel(path);
    }

    if (
      isNumericSegment(path) &&
      pathnames[index - 1] === "contact-support"
    ) {
      return "Case Details";
    }

    return labelMap[path] || path.charAt(0).toUpperCase() + path.slice(1);
  };

  const buildPath = (index) => {
    return "/" + pathnames.slice(0, index + 1).join("/");
  };

  return (
    <div className="flex items-center sm:gap-2 px-4 sm:px-8 py-3 bg-white border-b border-line">
      {/* Main Dashboard link */}
      <span className="text-primary text-xs sm:text-sm md:text-base font-bold hover:opacity-70 transition-opacity">
        Dashboard
      </span>

      {/* Vertical separator */}
      <span className="text-gray max-sm:mx-1.5">|</span>

      {/* Home link - always shown */}
      <NavLink
        to="/dashboard"
        className="text-primary text-xs sm:text-sm md:text-base font-bold hover:opacity-70 transition-opacity"
      >
        Home
      </NavLink>

      {/* Breadcrumb items */}
      {pathnames.length > 0 ? (
        pathnames.map((path, index) => {
          const isLast = index === pathnames.length - 1;
          const label = getLabel(path, index);
          const pathTo = buildPath(index);

          return (
            <React.Fragment key={pathTo}>
              <KeyboardArrowRightOutlinedIcon className="text-gray" />
              {isLast ? (
                <span className="text-muted text-xs sm:text-sm md:text-base font-normal">{label}</span>
              ) : (
                <NavLink
                  to={pathTo}
                  className="text-primary text-xs sm:text-sm md:text-base font-bold hover:opacity-70 transition-opacity"
                >
                  {label}
                </NavLink>
              )}
            </React.Fragment>
          );
        })
      ) : (
        // Show Dashboard as current page when on dashboard
        <>
          <KeyboardArrowRightOutlinedIcon className="text-gray" />
          <span className="text-muted font-normal text-xs sm:text-sm md:text-base">Dashboard</span>
        </>
      )}
    </div>
  );
};

export default Breadcrumb;
